export default __webpack_public_path__ + "static/media/image2.41a70527.jpeg";